import { combineReducers } from 'redux'
import AssessmentFile from './stores/assessment-file/assessment-file.reducer'
import Works from './stores/works/works.reducer'
import Discussion from './stores/discussion/discussion.reducer'
import CurrentInvitations from './stores/current-invitations/current-invitations.reducer'
import ArchivedInvitations from './stores/archived-invitations/archived-invitations.reducer'
import MyFiles from './stores/my-files/my-files.reducer'
import ArchivedFiles from './stores/archived-files/archived-files.reducer'
import Examples from './stores/examples/examples.reducer'
import Trainings from './stores/trainings/trainings.reducer'
import SchoolFiles from './stores/school-files/school-files.reducer'
import OrganisationFiles from './stores/organisation-files/organisation-files.reducer'

const Reducer = combineReducers({
  AssessmentFile,
  Works,
  Discussion,
  CurrentInvitations,
  ArchivedInvitations,
  MyFiles,
  ArchivedFiles,
  Examples,
  Trainings,
  SchoolFiles,
  OrganisationFiles
})

export default Reducer
